@let showSkeleton = transitionState() === "pending";

@if (showSkeleton || (tree().length === 0 && loading())) {
  <div class="d-flex flex-column gap-3 p-3 p-skeleton-group">
    <standard-skeleton width="4rem" height="26px" />
    <standard-skeleton height="26px" width="100%" />
    <standard-skeleton height="26px" width="80%" />
    <standard-skeleton height="26px" width="60%" />
    <standard-skeleton height="26px" width="40%" />
    <standard-skeleton height="26px" width="100%" />
    <standard-skeleton height="26px" width="80%" />
    <standard-skeleton height="26px" width="60%" />
    <standard-skeleton height="26px" width="40%" />
  </div>
} @else {
  <p-tree
    #primengTree
    styleClass="h-100 ms-3"
    [stickyParentNodes]="stickyParentNodes()"
    [value]="tree()"
    [trackBy]="trackTreeNode"
    [virtualScrollItemSize]="virtualScrollItemSize"
    [stickyParentItemSize]="stickyParentItemSize"
    [indentation]="undefined"
    [className]="activeGroupCode() === 'None' ? 'flat-tree' : ''"
    [metaKeySelection]="true"
    selectionMode="multiple"
    [(selection)]="selectedEngagements"
    (selectionChange)="handleSelectionChange($event)"
    (onNodeExpand)="onNodeStateChange($event)"
    (onNodeCollapse)="onNodeStateChange($event)"
    (keydown)="onTreeKeydown($event)"
  >
    <ng-template pTemplate="togglericon" let-expanded>
      <standard-collapse-icon
        [expanded]="!!expanded"
        [expandedRotateDeg]="360"
        [collapsedRotateDeg]="270"
      />
    </ng-template>

    <ng-template pTemplate="default" let-node>
      @if (node.children !== undefined) {
        <button
          class="w-100 cursor-pointer user-select-none text-decoration-none btn btn-link"
          (click)="onParentNodeClicked(node)"
        >
          <standard-line-clamp styleClass="fw-bold w-100" class="w-100">
            <span class="text-body">{{ node.label }}</span>
          </standard-line-clamp>
        </button>
      } @else {
        <app-workspace-list-tree-item
          #treeItem
          [node]="node"
          [aptVersion]="aptVersion()"
          [contextMenuItems]="contextMenuItems()"
          [contextMenuLoading]="contextMenuLoading()"
          (onMenuHover)="onMenuHover($event)"
          (onMenuToggled)="onMenuToggled($event)"
          (onRestoreRemoteClicked)="onRestoreRemoteClicked($event)"
          (onWorkspaceDoubleClicked)="onWorkspaceDoubleClicked($event)"
        />
      }
    </ng-template>
  </p-tree>
}

@if (showSkeleton || loading()) {
  <standard-page-blocking-spinner variant="panel" />
}
